import { configureStore } from '@reduxjs/toolkit';
import permissionReducer from './permissionSlice';
import timeZoneReducer from './timeZoneSlice';

export const store = configureStore({
  reducer: {
    permission: permissionReducer,
    timeZone: timeZoneReducer,
  },
});

// Inferred types for use throughout your app
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
